import { withAsyncLoading } from '../../../Components/Templates/Loading/AsyncPageLoading/withAsyncPageLoading';

const LoadableRHPage = withAsyncLoading(async () => import('./RHPage').then((res) => res.RHPage));

export { LoadableRHPage };
